// extracted by mini-css-extract-plugin
module.exports = {"copy":"SGSCopyButton_copy__2BhcF","check":"SGSCopyButton_check__22Ps1","copied":"SGSCopyButton_copied__RPbrh"};